import { DisplayProps } from './display';
import { SizeProps } from './size';
import { SpacingProps } from './spacing';
import { TextAlign } from './Box';
import { Theme, css } from '@emotion/react';

const returnFirstSpacingValueIfExists = (
  list: (number | undefined)[],
  spacing: (value: number) => number,
  declaration: string
): string => {
  const index = list.findIndex((n) => !!n);
  if (index === -1) {
    return '';
  }
  return declaration + ': ' + spacing(list[index] as number) + 'px';
};

const normalizeSizeValue = (property: string, value?: number | string): string => {
  if (typeof value === 'undefined') {
    return '';
  } else if (typeof value === 'number') {
    return property + ': ' + value + 'px;';
  } else {
    return property + ': ' + value + ';';
  }
};

// TODO: Update padding and margin to use spacing not rem
export const boxStyle = (
  { spacing }: Theme,
  { mt, mb, my, ml, mr, mx, margin, pt, pb, py, pl, pr, px, padding }: SpacingProps,
  { display }: DisplayProps,
  { height, minHeight, maxHeight, width, minWidth, maxWidth }: SizeProps,
  textAlign: TextAlign
) => css`
  ${returnFirstSpacingValueIfExists([margin, my, mt], spacing, 'margin-top')};
  ${returnFirstSpacingValueIfExists([margin, my, mb], spacing, 'margin-bottom')};
  ${returnFirstSpacingValueIfExists([margin, mx, ml], spacing, 'margin-left')};
  ${returnFirstSpacingValueIfExists([margin, mx, mr], spacing, 'margin-right')};

  ${returnFirstSpacingValueIfExists([padding, py, pt], spacing, 'padding-top')};
  ${returnFirstSpacingValueIfExists([padding, py, pb], spacing, 'padding-bottom')};
  ${returnFirstSpacingValueIfExists([padding, px, pl], spacing, 'padding-left')};
  ${returnFirstSpacingValueIfExists([padding, px, pr], spacing, 'padding-right')};

  display: ${display};
  text-align: ${textAlign};
  ${normalizeSizeValue('height', height)};
  ${normalizeSizeValue('min-height', minHeight)};
  ${normalizeSizeValue('max-height', maxHeight)};
  ${normalizeSizeValue('width', width)};
  ${normalizeSizeValue('min-width', minWidth)};
  ${normalizeSizeValue('max-width', maxWidth)};
`;
